<div
  data-testid="select-corporate-traveller-dropdown"
  class="nordic-blue-25-bg ps-small ms-small-b rounded-large font-body-1 relative"
>
  <fcom-text-input
    #searchInput
    [parentForm]="form"
    [controlName]="'search'"
    [translationPrefix]="'paxDetails.corporate.selectPassenger'"
    [displayMargin]="false"
    [disableAutoComplete]="true"
    [clearInput]="true"
  />
  @if (filteredUsers$ | async; as users) {
    <div data-testid="corporate-users-list-in-dropdown" class="absolute fill z1 ms-xxsmall-t ps-large-r">
      <div class="white-bg elevation-level-1 border overflow-hidden rounded-large">
        <ul class="no-list-style" role="listbox">
          @for (user of users; track user; let isLast = $last) {
            <li
              [attr.data-testid]="'select-traveller-' + (user.firstname | finKebab) + '-' + (user.lastname | finKebab)"
              class="search-result"
              role="option"
              [attr.aria-selected]="(selectedUser$ | async) === user"
              [ngClass]="{ 'border-bottom': !isLast }"
            >
              <a href="#" class="nordic-blue-900-text no-underline block ps-small" (click)="selectUser(user, $event)">
                {{ user.firstname }} {{ user.lastname }}
              </a>
            </li>
          }
          @if (!users.length) {
            <li class="ps-small">
              {{ 'paxDetails.corporate.noMatches' | finLocalization }}
            </li>
          }
        </ul>
      </div>
    </div>
  }
</div>
